import { dbTableCampaign } from "@dataseat-dsp-client/lib-reporter";

export const CAMPAIGN_SELECT_QUERY_MAP =
  dbTableCampaign.CAMPAIGN_SELECT_QUERY_MAP;

export type queryDistinctValuesArgs = dbTableCampaign.queryDistinctValuesArgs;
export const QUERY_DISTINCT_VALUES = dbTableCampaign.QUERY_DISTINCT_VALUES;
